import { render, staticRenderFns } from "./CheckListItem.vue?vue&type=template&id=163b9c33&scoped=true&"
import script from "./CheckListItem.vue?vue&type=script&lang=js&"
export * from "./CheckListItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckListItem.vue?vue&type=style&index=0&id=163b9c33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163b9c33",
  null
  
)

export default component.exports